import Dialog from "@material-ui/core/Dialog";
import {
  CloseButton,
  FormTitle,
  InfoArea,
  SmallTitleText,
  StyledPaper,
} from "../../../underwriterDashboard/idpDocuments/styles";
import CloseIcon from "@material-ui/icons/Close";
import Success from "../../../../assets/dashboardIcons/Success";
import { FunctionalButton } from "../../../../components/functionalButton";
import React from "react";
import { useHistory } from "react-router-dom";

export const SuccessPopup = ({ open, setOpen }) => {
  const history = useHistory();
  const handleClose = () => setOpen(false);

  const handleGoBackToDashboard = () => {
    history.push("/underwriter-dashboard");
  }

  const handleGoBackToESub = () => {
    history.push("/prequalify/preview/ecqs");
  }

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
    >
      <StyledPaper elevation={0}>
        <CloseButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
        <Success isMobile={undefined} />
        <FormTitle
          style={{
            marginTop: "20px",
            color: "#1A051D",
            fontSize: "22px",
            fontWeight: "600",
            fontStyle: "normal",
            lineHeight: "24px",
            marginBottom: "20px"
          }}
        >
          Underwriters Invited Successfully
        </FormTitle>
        <SmallTitleText
          style={{
            marginBottom: 10,
          }}
        >
          They can view your submission by
          clicking the "View All eSUB" button on their dashboard.
        </SmallTitleText>
        <InfoArea>
          <FunctionalButton
            buttonTitle="Go Back to Dashboard"
            handleButton={handleGoBackToDashboard}
            width="300px"
            height="48px"
            isReversedColor={true}
            marginRight={"16px"}
            marginLeft={"0px"}
            marginTop={"30px"}
            marginBottom={"20px"}
            fontSize={"18px"}
            disabled={false}
            icon={null}
            hasBoxShadow={true}
            frontIcon={null}
            weight={600}
            borderColor={undefined}
            selected={undefined}
          />
          <FunctionalButton
            buttonTitle="Go Back To eSUB"
            handleButton={handleGoBackToESub}
            width="300px"
            height="48px"
            isReversedColor={false}
            marginRight={"0px"}
            marginLeft={"0px"}
            marginTop={"30px"}
            marginBottom={"20px"}
            fontSize={"18px"}
            disabled={false}
            icon={null}
            hasBoxShadow={true}
            frontIcon={null}
            weight={600}
            borderColor={undefined}
            selected={undefined}
            preserveCase
          />
        </InfoArea>
      </StyledPaper>
    </Dialog>
  );
};
